import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { noop } from 'lodash-es';

@Component({
  selector: 'hlu-numeric-stepper',
  templateUrl: './numeric-stepper.component.html',
  styleUrls: ['./numeric-stepper.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumericStepperComponent),
      multi: true,
    },
  ],
})
export class NumericStepperComponent implements ControlValueAccessor {
  private innerValue = 0;
  @Input() prefixLabel: string;
  @Input() suffixLabel: string;
  isDisabled = false;

  get value() {
    return this.innerValue;
  }
  set value(v: number) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  // Placeholders for the callbacks which are later provided
  // by the Control Value Accessor
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  // Set touched on blur
  onBlur(): void {
    this.onTouchedCallback();
  }

  writeValue(value: number): void {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  registerOnChange(fn: () => void): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  increase(): void {
    this.value++;
  }

  decrease(): void {
    this.value--;
  }
}
